<div class="stats-side-by-side-container">
    <div class="stats-column">
        <mat-card>
            <mat-card-title>
                <h2 i18n>Weekly Stats Collector</h2>
            </mat-card-title>
            <mat-card-content>
                <div class="selectors-row">
                    <div class="selector-item">
                        <mat-form-field>
                            <mat-select (selectionChange)="setSelectedUser($event)" [compareWith]="compareObjects"
                                        [disabled]="!canModifyAll"
                                        [value]="selectedUser" placeholder="User">
                                @for (user of users; track user) {
                                    <mat-option [value]="user">
                                        {{ user.displayName }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    @if (canModifyAll) {
                        <div class="selector-item">
                            <mat-form-field>
                                <input (dateChange)="changeDate($event)" [matDatepicker]="picker" [max]="maxDate"
                                       [value]="selectedDate" matInput
                                       placeholder="Choose a date">
                                <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    }
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p>
                            <i i18n>Report for week: {{ selectedWeek }} (today
                                is {{ today.toDate() | date: 'dd/MM/yyyy' }})</i>
                        </p>
                        @if (currentReport && currentReport.lastModifiedDate) {
                            <p>
                                <i i18n>Last modified on: {{ currentReport.lastModifiedDate | date: 'dd/MM/yyyy' }} by
                                    {{ currentReport.lastModifiedBy }}</i>
                            </p>
                        }
                    </div>
                </div>

                <form (ngSubmit)="save(statsForm.value, statsForm.valid)" [formGroup]="statsForm" novalidate>
                    <div class="row">
                        @for (field of currentUserStatFields; track field) {
                            <div class="col-sm-3">
                                @if (field.isManual && field.name === 'projectEfficiency') {
                                    <mat-select formControlName="{{ field.name }}"
                                                placeholder="{{ field.description }}">
                                        @for (opt of projectEfficencyOptions; track opt) {
                                            <mat-option [value]="opt.value">
                                                {{ opt.name }}
                                            </mat-option>
                                        }

                                    </mat-select>
                                } @else if (field.isManual) {
                                    <mat-form-field>
                                        <mat-label>{{ field.description }}</mat-label>
                                        <input [formControlName]="field.name" matInput
                                               type="number">
                                    </mat-form-field>
                                }
                            </div>
                        }
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <button [disabled]="disableSubmit" color="primary" mat-raised-button
                                    type="submit">Submit
                            </button>
                        </div>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="stats-column">
        <mat-card>
            <mat-card-title>
                <h2 i18n>Previous reports</h2>

                <div>
                    <button color="primary"
                            mat-icon-button
                            matTooltip="go to the dashboards"
                            [routerLink]="['dashboard' ]">
                        <mat-icon>analytics</mat-icon>
                    </button>
                </div>
            </mat-card-title>
            <mat-card-content>
                <app-statcollector-list [currentUserStatFields]="currentUserStatFields" [selectedUser]="selectedUser">
                </app-statcollector-list>
            </mat-card-content>
        </mat-card>
    </div>
</div>